import { render } from "./ConfigTextAreaInput.vue?vue&type=template&id=e394e160&scoped=true&ts=true"
import script from "./ConfigTextAreaInput.vue?vue&type=script&lang=ts"
export * from "./ConfigTextAreaInput.vue?vue&type=script&lang=ts"

import "./ConfigTextAreaInput.vue?vue&type=style&index=0&id=e394e160&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e394e160"]])

export default __exports__